<template>
  <full-container v-loading="loading" :element-loading-text="loadingText" :padding="0">
    <div class="toolbar">
      <el-upload :before-upload="handleUpload" action="default" :disabled="loading">
        <el-button type="primary" size="small" icon="el-icon-upload"> 选择要导入的 .xlsx 表格 </el-button>
      </el-upload>
    </div>

    <el-table :data="datalist[pape]" size="mini" stripe height="100%">
      <el-table-column prop="Publish" label="发货日期" min-width="100" show-overflow-tooltip />
      <el-table-column prop="Code" label="单号" min-width="80" show-overflow-tooltip />
      <el-table-column prop="Customer" label="客户简称" min-width="150" show-overflow-tooltip />
      <el-table-column label="商品数量" min-width="80" show-overflow-tooltip>
        <span slot-scope="{ row }">{{ row.Items.length }}条</span>
      </el-table-column>
      <el-table-column prop="Paytime" label="回款时间" min-width="100" show-overflow-tooltip />
      <el-table-column prop="Amount" label="金额" min-width="80" show-overflow-tooltip />
      <el-table-column label="部门/销售" min-width="120" show-overflow-tooltip>
        <span slot-scope="{ row }">{{ row.Department }}{{ row.Salesman }}</span>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-pagination :page-size="size" :total="total" @current-change="onPager" />
      <el-button type="primary" size="small" icon="el-icon-caret-right" :disabled="loading" @click="onSubmit(0)">开始导入</el-button>
    </div>
  </full-container>
</template>

<script>
import Vue from 'vue'
import pluginImport from '@d2-projects/vue-table-import'
Vue.use(pluginImport)
export default {
  data () {
    return {
      loading: false,
      loadingText: "",
      datalist: [],
      total: 0,
      pape: 0,
      size: 200,
    }
  },
  methods: {
    //上传文件
    handleUpload (file) {
      if (this.loading) {
        return
      }
      this.loading = true
      this.loadingText = "正在加载文件数据..."
      this.$import
        .xlsx(file)
        .then(({ results }) => {
          let groups = this.GroupItems(results)
          this.total = groups.length
          this.datalist = this.splitArr(groups, this.size)
        })
        .catch((e) => {
          this.$message.error(e)
        }).finally(() => {
          this.loading = false
        })
      return false
    },
    // 分页触发事件
    onPager (val) {
      this.pape = val - 1
    },


    //分组
    GroupItems (sources) {
      let key = "单号"
      let res = [], types = {}
      sources.forEach(row => {
        if (!(row[key] in types)) {
          types[row[key]] = {
            Code: row[key],
            Publish: row['发货日期'],
            Customer: row['客户简称'],
            Department: row['部门'],
            Salesman: row['业务员'],
            Type: row['业务分类'],
            Paytime: row['回款时间'],
            Amount: row['回款金额'],
            Remarks: row['备注'],
            Items: []
          }
          res.push(types[row[key]])
        }
        let item = {
          OutboundCode: row[key],
          Code: row['存货编码'],
          Name: row['货物名称'],
          Spec: String(row['规格型号']),
          Unit: row['单位'],
          Quantity: row['数量'],
          Price: row['单价']
        }
        types[row[key]].Items.push(item)
      })
      return res
    },

    //分页
    splitArr (data, senArrLen) {
      //处理成len个一组的数据
      let data_len = data.length
      let arrOuter_len = data_len % senArrLen === 0 ? data_len / senArrLen : parseInt((data_len / senArrLen) + '') + 1
      let arrSec_len = data_len > senArrLen ? senArrLen : data_len//内层数组的长度
      let arrOuter = new Array(arrOuter_len)//最外层数组
      let arrOuter_index = 0//外层数组的子元素下标
      for (let i = 0; i < data_len; i++) {
        if (i % senArrLen === 0) {
          arrOuter_index++
          let len = arrSec_len * arrOuter_index
          //将内层数组的长度最小取决于数据长度对len取余，平时最内层由下面赋值决定
          arrOuter[arrOuter_index - 1] = new Array(data_len % senArrLen)
          if (arrOuter_index === arrOuter_len)//最后一组
            data_len % senArrLen === 0 ?
              len = data_len % senArrLen + senArrLen * arrOuter_index :
              len = data_len % senArrLen + senArrLen * (arrOuter_index - 1)
          let arrSec_index = 0//第二层数组的索引
          for (let k = i; k < len; k++) {//第一层数组的开始取决于第二层数组长度*当前第一层的索引
            arrOuter[arrOuter_index - 1][arrSec_index] = data[k]
            arrSec_index++
          }
        }
      }
      return arrOuter
    },
    //提交数据
    onSubmit (index) {
      if (index < 0) { index = 0 }

      if (!this.loading) {
        this.loading = true
      }
      this.loadingText = "正在上传第" + (index + 1) + "页"
      this.$apis.product.outbound.import(this.datalist[index])
        .catch((res) => {
          this.$message.error(res)
        })
        .finally(() => {
          if (!this.datalist[index + 1]) {
            this.$message({ message: '数据全部已上传', type: 'success' })
            this.loading = false
          }
          else {
            this.onSubmit(index + 1)
          }
        })
    }
  }
}
</script>
